module.exports = __webpack_public_path__ + "static/img/home-new4.487ba815.jpg";